import mitt from 'mitt';

export default () => {
  if (!window.emitter) {
    window.emitter = mitt();
  }
  return window.emitter || { on: () => {}, off: () => {}, emit: () => {} };
};
